import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter } from '@fortawesome/free-brands-svg-icons';

export default function TwitterMetadataIcon() {
  return (
    <div className="itemMetadata-twitterIcon itemMetadata-fontawesome">
      <FontAwesomeIcon icon={faTwitter} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_items_v2/message/twitter_metadata_icon.jsx